export const USER_ERROR_MESSAGES = {
  FETCH_USERS: "Failed to fetch users",
  FETCH_USER: "Failed to fetch user",
  CREATE_USER: "Failed to create user",
  UPDATE_USER: "Failed to update user",
  DELETE_USER: "Failed to delete user",
  FETCH_PERMISSIONS: "Failed to fetch user permissions",
};

export const FEATURE_ERROR_MESSAGES = {
  FETCH_FEATURES: "Failed to fetch features",
  FETCH_FEATURE: "Failed to fetch feature",
  CREATE_UPDATE_FEATURE: "Failed to create/update feature",
  UPDATE_GATING_STATUS: "Failed to update gating status",
  UPDATE_FEATURE_USERS: "Failed to update feature users",
  DELETE_FEATURE: "Failed to delete feature",
};

export const ROLE_OPTIONS = [
  { value: "READ", label: "READ" },
  { value: "CUSTOM", label: "CUSTOM" },
  { value: "ADMIN", label: "ADMIN" },
];

export const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "ACTIVE" },
  { value: "INACTIVE", label: "INACTIVE" },
];
